import * as React from 'react';
import {connect} from 'react-redux';
import {deactivate, setScreen} from "../../actions/activation";
import {ShareComponent} from "./controls/Share";

class AfterShareComponent extends React.Component {
	state = {};

	constructor(props) {
		super(props);
	}

	render() {
		const {ui,videoVersion} = this.props;
		const shareTexts = window.shareTexts ? window.shareTexts : {};
		const defaultData = {
			title : 'Gloop Sent!',
			text : 'Signing up lets you:',
			signUpHref: 'default',
			signUpText: 'default',
			noThanksHref: '#',
			noThanks: 'default',
			icon : '/wp-content/plugins/gloop-addons/images/file.gif'
		}
		const shareData = shareTexts[ui.shareTo] ? Object.assign({}, defaultData ,shareTexts[ui.shareTo]) : defaultData
		return (
			<div className={'after-share-gloop'}>
				<div className={'after-share-block'}>
					<div className={'aftershare-image-gloop'}>
						<img src={shareData.icon} alt={""} />
					</div>
					<div className={'aftershare-content'}>
						<h4>{shareData.title}</h4>
						<ul className={'benefits-list-gloop'}>
							{shareData.text.map(item => <li>{item}</li>)}
						</ul>
						<a
							href={shareData.signUpHref}
							className={'signup-gloop'}
							onClick={ (e) => {
								e.preventDefault();
								setScreen(videoVersion ? 'share' : 'shareStart');
							}}
						>{shareData.signUpText}</a>
						<a
							href={shareData.noThanksHref}
							className={'cancel'}
							onClick={deactivate}
						>{shareData.noThanks}</a>
					</div>
				</div>
			</div>
		)
	}
}


const mapStateToProps = (state) => {
	return {
		videoVersion : state.videoVersion,
		ui: state.ui,
	};
}
const AfterShare = connect(mapStateToProps)(AfterShareComponent)
export default AfterShare;
